///ts:ref=Building
/// <reference path="./Building.ts"/> ///ts:ref:generated

interface TowerDesc {
	baseTex: PIXI.Texture;
	turretTex: PIXI.Texture;
	trunkTex?: PIXI.Texture;
	trunks?: Array<number>;
	bulletNumber?: number;
	bulletSpeed?: number;
	bulletScale?: number;
	bulletTargeting?: boolean;
}

class TrunkSprite extends PIXI.Sprite {
	shift = 0;

	constructor(texture: PIXI.Texture) {
		super(texture);
		this.pivot.set(50, 0);
		this.anchor.set(0, 0.5);
	}
}

function centerFrickingSprite(spr: PIXI.Sprite) {
	const w = spr.texture.orig.width >> 1;
	const h = spr.texture.orig.height >> 1;
	const w2 = w >> 1;
	const h2 = h >> 1;
	spr.anchor.set(w2 / w, h2 / h);
	const sprAny = spr as any;
	if (sprAny.updateText) {
		sprAny.updateText(true);
	}
}

class Tower extends Building {
	desc: TowerDesc;
	base: PIXI.Sprite;
	rotating: PIXI.Container;
	turret: PIXI.Sprite;
	trunks: Array<TrunkSprite> = [];
	curTrunk: number = 0;

	constructor(desc: TowerDesc, dict: MobDict) {
		super(dict);
		this.base = new PIXI.Sprite(desc.baseTex);
		this.addChild(this.base);
		this.rotating = new PIXI.Container();
		this.addChild(this.rotating);

		this.turret = new PIXI.Sprite(desc.turretTex);

		this.setDesc(desc);
	}

	setDesc(desc: TowerDesc) {
		this.desc = desc;
		this.base.texture = desc.baseTex;
		this.turret.texture = desc.turretTex;

		centerFrickingSprite(this.base);
		this.base.pivot.set(-2, -2);
		centerFrickingSprite(this.turret);

		this.createTrunks();
	}

	createTrunks() {
		const desc = this.desc;
		const rot = this.rotating;
		rot.removeChildren();

		this.trunks = [];
		if (desc.trunks) {
			const len = desc.trunks.length;
			for (let i = 0; i < len; i += 2) {
				const tr = new TrunkSprite(desc.trunkTex);
				tr.pivot.x -= desc.trunks[i];
				tr.position.y = desc.trunks[i + 1];
				this.trunks.push(tr);
				tr.shift += i * Math.PI * 2 / len;
				rot.addChild(tr);
			}
		}
		// this.turret.alpha = 0.3;
		rot.addChild(this.turret);
	}

	shotsMade = 0;

	static ZERO = new PIXI.Point(0, 0);

	updateShots(delta: number) {
		const desc = this.desc;
		const v = this.shots.length;

		const t = this.trunks.length;
		let c = this.curTrunk % (t || 1);
		let st = Math.random() / v * delta;

		let avgAngle = 0;

		for (let i = 0; i < v; i++) {
			const bullet = new Bullet(Assets.allBullets[desc.bulletNumber || 0]);
			const shot = this.shots[i];

			if (!t) {
				bullet.position.copy(this.position);
			} else {
				this.trunks[c].toGlobal(Tower.ZERO, bullet.position);
				c = (c + 1) % t;
			}

			bullet.shooter = this;
			bullet.targetPos = shot.targetPosition;
			bullet.updateMove(st);
			st += i / v * delta;
			for (let j = 0; j < shot.targetMobs.length; j++) {
				(shot.targetMobs[j] as Bunny).killerBullet = bullet;
				if (desc.bulletTargeting) {
					bullet.targetMob = shot.targetMobs[j] as Bunny;
					bullet.targetMobLife = bullet.targetMob.lifeNumber;
				}
			}

			if (desc.bulletSpeed) {
				bullet.speed = desc.bulletSpeed;
			}

			if (desc.bulletScale) {
				bullet.scale.set(desc.bulletScale);
			}

			//same as addChild
			Game.bulletsContainer.addChild(bullet);

			//average angle
			let ang = Math.atan2(shot.targetPosition.y - this.position.y,
				shot.targetPosition.x - this.position.x);
			ang -= Math.PI;
			ang -= this.rotating.rotation;
			while (ang > Math.PI) {
				ang -= Math.PI * 2;
			}
			while (ang < -Math.PI) {
				ang += Math.PI * 2;
			}
			avgAngle += ang;
		}

		this.shots.length = 0;
		this.shotsMade = v;
		this.curTrunk = c;

		if (this.rotating.visible && this.zombie) {
			this.rotating.visible = false;
		}

		if (v > 0 && t) {
			this.rotating.rotation += avgAngle / v * 0.2;
		}
	}

	updateAnim(delta: number) {
		super.updateAnim(delta);
		// no updates yet
		const trunks = this.trunks;
		for (let i = 0; i < trunks.length; i++) {
			const trunk = trunks[i];
			trunk.shift += delta * 0.3;
			trunk.position.x = (Math.cos(trunk.shift) + 1.0) * 5;
		}
	}
}

